import { Component, OnDestroy, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
import { Subscription } from 'rxjs';
import { PermissionsService } from '../../../services/permission.service';
import { DialogConfig, FormField } from '../../../shared/components/reusable-dialog/form-field.interface';

@Component({
  selector: 'app-ship',
  standalone: false,
  templateUrl: './ship.component.html',
  styleUrl: './ship.component.scss'
})
export class ShipComponent implements OnInit, OnDestroy {
  title = 'Ship Table';
  showDialog: boolean = false;
  isUpdatedialog: boolean = false;
  private subscriptions = new Subscription();
  system: any[]=[]
  // isCardView: boolean = true;
  cols: any[] = [
    { field: 'name', header: 'Ship Name', filterType: 'text', width: '200px' },
    { field: 'address', header: 'Address', filterType: 'text', width: '300px' },

  ];
  selectedsystem: any;
  systemSection: any;
  showDeleteDialog: boolean = false;
  selectedShipData: any = {};
  viewMode: boolean = false;
  
  // Dialog configurations
  addDialogConfig: DialogConfig;
  updateDialogConfig: DialogConfig;

  constructor(private api: ApiService, private messageService: MessageService , private permissionService: PermissionsService) { }

  ngOnInit(): void {
    this.getSystem();
    this.initializeDialogConfigs();
  }

  private initializeDialogConfigs(): void {
    const shipFields: FormField[] = [
      {
        key: 'sr_no',
        label: 'Serial Number',
        type: 'text',
        placeholder: 'Enter Serial Number',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Only letters, numbers, spaces and & are allowed'
      },
      {
        key: 'code',
        label: 'Code',
        type: 'text',
        placeholder: 'Enter Code',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Only letters, numbers, spaces and & are allowed'
      },
      {
        key: 'name',
        label: 'Name',
        type: 'text',
        placeholder: 'Enter Ship Name',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Only letters, numbers, spaces and & are allowed'
      },
      {
        key: 'commission_date',
        label: 'Commission Date',
        type: 'date',
        placeholder: 'Select Commission Date',
        validation: {
          required: true
        }
      },
      {
        key: 'ops_code',
        label: 'OPS Code',
        type: 'text',
        placeholder: 'Enter OPS Code',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Only letters, numbers, spaces and & are allowed'
      },
      {
        key: 'ship_builder',
        label: 'Ship Builder',
        type: 'text',
        placeholder: 'Enter Ship Builder',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Only letters, numbers, spaces and & are allowed'
      },
      {
        key: 'decommission_date',
        label: 'Decommission Date',
        type: 'date',
        placeholder: 'Select Decommission Date',
        validation: {
          required: true
        }
      },
      {
        key: 'displacement',
        label: 'Displacement',
        type: 'text',
        placeholder: 'Enter Displacement',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[0-9.,]+$'
        },
        patternErrorMessage: 'Only numbers, decimals and commas are allowed'
      },
      {
        key: 'hours_underway',
        label: 'Hours Underway',
        type: 'text',
        placeholder: 'Enter Hours Underway',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[0-9.,]+$'
        },
        patternErrorMessage: 'Only numbers, decimals and commas are allowed'
      },
      {
        key: 'distance_run',
        label: 'Distance Run',
        type: 'text',
        placeholder: 'Enter Distance Run',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[0-9.,]+$'
        },
        patternErrorMessage: 'Only numbers, decimals and commas are allowed'
      },
      {
        key: 'decommission_scheduled_date',
        label: 'Decommission Scheduled Date',
        type: 'date',
        placeholder: 'Select Decommission Scheduled Date',
        validation: {
          required: true
        }
      },
      {
        key: 'sdrsref',
        label: 'SDRS Ref',
        type: 'text',
        placeholder: 'Enter SDRS Ref',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Only letters, numbers, spaces and & are allowed'
      },
      {
        key: 'yard_no',
        label: 'Yard No',
        type: 'text',
        placeholder: 'Enter Yard No',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Only letters, numbers, spaces and & are allowed'
      },
      {
        key: 'reference_no',
        label: 'Reference No',
        type: 'text',
        placeholder: 'Enter Reference No',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Only letters, numbers, spaces and & are allowed'
      },
      {
        key: 'classification_society',
        label: 'Classification Society',
        type: 'text',
        placeholder: 'Enter Classification Society',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Only letters, numbers, spaces and & are allowed'
      },
      {
        key: 'length_overall',
        label: 'Length Overall',
        type: 'text',
        placeholder: 'Enter Length Overall',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[0-9. ]+[a-zA-Z]*$'
        },
        patternErrorMessage: 'Only numbers, decimals and optional units are allowed'
      },
      {
        key: 'length_perpen',
        label: 'Length Perpen',
        type: 'text',
        placeholder: 'Enter Length Perpen',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[0-9. ]+[a-zA-Z]*$'
        },
        patternErrorMessage: 'Only numbers, decimals and optional units are allowed'
      },
      {
        key: 'module_breath',
        label: 'Module Breath',
        type: 'text',
        placeholder: 'Enter Module Breath',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[0-9. ]+[a-zA-Z]*$'
        },
        patternErrorMessage: 'Only numbers, decimals and optional units are allowed'
      },
      {
        key: 'wetted_under_water',
        label: 'Wetted Under Water',
        type: 'text',
        placeholder: 'Enter Wetted Under Water',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[0-9. ]+[a-zA-Z]*$'
        },
        patternErrorMessage: 'Only numbers, decimals and optional units are allowed'
      },
      {
        key: 'depth_main',
        label: 'Depth Main',
        type: 'text',
        placeholder: 'Enter Depth Main',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[0-9. ]+[a-zA-Z]*$'
        },
        patternErrorMessage: 'Only numbers, decimals and optional units are allowed'
      },
      {
        key: 'standard_disp',
        label: 'Standard Disp',
        type: 'text',
        placeholder: 'Enter Standard Disp',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[0-9. ]+[a-zA-Z]*$'
        },
        patternErrorMessage: 'Only numbers, decimals and optional units are allowed'
      },
      {
        key: 'full_load_disp',
        label: 'Full Load Disp',
        type: 'text',
        placeholder: 'Enter Full Load Disp',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[0-9. ]+[a-zA-Z]*$'
        },
        patternErrorMessage: 'Only numbers, decimals and optional units are allowed'
      },
      {
        key: 'stand_draft',
        label: 'Stand Draft',
        type: 'text',
        placeholder: 'Enter Stand Draft',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[0-9. ]+[a-zA-Z]*$'
        },
        patternErrorMessage: 'Only numbers, decimals and optional units are allowed'
      },
      {
        key: 'full_load_draft',
        label: 'Full Load Draft',
        type: 'text',
        placeholder: 'Enter Full Load Draft',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[0-9. ]+[a-zA-Z]*$'
        },
        patternErrorMessage: 'Only numbers, decimals and optional units are allowed'
      },
      {
        key: 'wetted_boot_top',
        label: 'Wetted Boot Top',
        type: 'text',
        placeholder: 'Enter Wetted Boot Top',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[0-9. ]+[a-zA-Z]*$'
        },
        patternErrorMessage: 'Only numbers, decimals and optional units are allowed'
      },
      {
        key: 'engine_rating',
        label: 'Engine Rating',
        type: 'text',
        placeholder: 'Enter Engine Rating',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[0-9. ]+[a-zA-Z]*$'
        },
        patternErrorMessage: 'Only numbers, decimals and optional units are allowed'
      },
      {
        key: 'max_cont_speed',
        label: 'Max Cont Speed',
        type: 'text',
        placeholder: 'Enter Max Cont Speed',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[0-9. ]+[a-zA-Z]*$'
        },
        patternErrorMessage: 'Only numbers, decimals and optional units are allowed'
      },
      {
        key: 'eco_speed',
        label: 'Eco Speed',
        type: 'text',
        placeholder: 'Enter Eco Speed',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[0-9. ]+[a-zA-Z]*$'
        },
        patternErrorMessage: 'Only numbers, decimals and optional units are allowed'
      },
      {
        key: 'endurance',
        label: 'Endurance',
        type: 'text',
        placeholder: 'Enter Endurance',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[0-9. ]+[a-zA-Z]*$'
        },
        patternErrorMessage: 'Only numbers, decimals and optional units are allowed'
      },
      {
        key: 'remark',
        label: 'Remark',
        type: 'text',
        placeholder: 'Enter Remark',
        maxLength: 250,
        validation: {
          required: true
        }
      },
      {
        key: 'refit_authority',
        label: 'Refit Authority',
        type: 'text',
        placeholder: 'Enter Refit Authority',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Only letters, numbers, spaces and & are allowed'
      },
      {
        key: 'signal_name',
        label: 'Signal Name',
        type: 'text',
        placeholder: 'Enter Signal Name',
        maxLength: 250,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Only letters, numbers, spaces and & are allowed'
      },
      {
        key: 'address',
        label: 'Address',
        type: 'text',
        placeholder: 'Enter Address',
        maxLength: 250,
        validation: {
          required: true
        }
      },
      {
        key: 'contact_number',
        label: 'Contact Number',
        type: 'text',
        placeholder: 'Enter Contact Number',
        maxLength: 10,
        validation: {
          required: true,
          pattern: '^[6-9]\\d{9}$'
        },
        patternErrorMessage: 'Please enter a valid 10-digit phone number starting with 6-9'
      },
      {
        key: 'nud_email_id',
        label: 'NUD Email',
        type: 'email',
        placeholder: 'Enter NUD Email',
        maxLength: 250,
        validation: {
          required: true
        }
      },
      {
        key: 'nic_email_id',
        label: 'NIC Email',
        type: 'email',
        placeholder: 'Enter NIC Email',
        maxLength: 250,
        validation: {
          required: true
        }
      }
    ];

    this.addDialogConfig = {
      title: 'Create Ship',
      width: '80vw',
      fields: shipFields,
      formLayout: 'two-column',
      submitButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      showCancelButton: true,
      maximizable: true,
      closable: true,
      dismissableMask: true,
      styleClass: 'custom-ship-dialog'
    };

    this.updateDialogConfig = {
      title: 'Update Ship',
      width: '80vw',
      fields: shipFields,
      formLayout: 'two-column',
      submitButtonText: 'Update',
      cancelButtonText: 'Cancel',
      showCancelButton: true,
      maximizable: true,
      closable: true,
      dismissableMask: true,
      styleClass: 'custom-ship-dialog'
    };
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  totalRecords: number = 0;
  getSystem(event: { page: number; search?: string } = { page: 1 }) {
     const page = event.page || 1;
    const search = event.search?.trim();

    let url = `/master/ship/?page=${page}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    const sub = this.api.getAPI(url).subscribe((res) => {
      // this.system = res.map((item: any) => ({
      //   ...item,
      //   section: item.section?.name,
      //   sectionName: item.section?.name || '',
      //   sectionCode: item.section?.code || '',
      //   status: item.status === 1 ? 'Active' : 'Inactive' // readable status
      // }));
      this.system = res.data || res.results
       this.totalRecords = res.count || 0

    });
    this.subscriptions.add(sub);
  }


  addSystem() {
    this.selectedShipData = {};
    this.showDialog = true;
  }

  onSubmitAdd(formData: any) {
    let payload = {
      sr_no: formData.sr_no,
      code: formData.code,
      name: formData.name,
      commission_date: formData.commission_date,
      ops_code: formData.ops_code,
      ship_builder: formData.ship_builder,
      decommission_date: formData.decommission_date,
      displacement: formData.displacement,
      hours_underway: formData.hours_underway,
      distance_run: formData.distance_run,
      decommission_scheduled_date: formData.decommission_scheduled_date,
      sdrsref: formData.sdrsref,
      yard_no: formData.yard_no,
      reference_no: formData.reference_no,
      classification_society: formData.classification_society,
      length_overall: formData.length_overall,
      length_perpen: formData.length_perpen,
      module_breath: formData.module_breath,
      wetted_under_water: formData.wetted_under_water,
      depth_main: formData.depth_main,
      standard_disp: formData.standard_disp,
      full_load_disp: formData.full_load_disp,
      stand_draft: formData.stand_draft,
      full_load_draft: formData.full_load_draft,
      wetted_boot_top: formData.wetted_boot_top,
      engine_rating: formData.engine_rating,
      max_cont_speed: formData.max_cont_speed,
      eco_speed: formData.eco_speed,
      endurance: formData.endurance,
      remark: formData.remark,
      refit_authority: formData.refit_authority,
      signal_name: formData.signal_name,
      address: formData.address,
      contact_number: formData.contact_number,
      nud_email_id: formData.nud_email_id,
      nic_email_id: formData.nic_email_id
    };
    
    const sub = this.api.postAPI('/master/ship/', payload).subscribe((res: any) => {
      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Ship submitted successfully'
        });
        this.showDialog = false;
        this.getSystem();
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Failed',
          detail: res.name || 'Failed to create ship'
        });
      }
    });
    this.subscriptions.add(sub);
  }

  onCancelAdd() {
    this.showDialog = false;
  }

  onCloseAdd() {
    this.showDialog = false;
  }

  viewSystem(equipment: any) {
    this.viewMode = true;
    this.updateDialogConfig.title = 'View Ship';
    if (equipment && equipment.id) {
      this.selectedsystem = equipment;
      this.isUpdatedialog = true;
      
      // Map data for the reusable dialog
      this.selectedShipData = {
        sr_no: equipment.sr_no || '',
        code: equipment.code || '',
        name: equipment.name || '',
        commission_date: equipment.commission_date || '',
        ops_code: equipment.ops_code || '',
        ship_builder: equipment.ship_builder || '',
        decommission_date: equipment.decommission_date || '',
        displacement: equipment.displacement || '',
        hours_underway: equipment.hours_underway || '',
        distance_run: equipment.distance_run || '',
        decommission_scheduled_date: equipment.decommission_scheduled_date || '',
        sdrsref: equipment.sdrsref || '',
        yard_no: equipment.yard_no || '',
        reference_no: equipment.reference_no || '',
        classification_society: equipment.classification_society || '',
        length_overall: equipment.length_overall || '',
        length_perpen: equipment.length_perpen || '',
        module_breath: equipment.module_breath || '',
        wetted_under_water: equipment.wetted_under_water || '',
        depth_main: equipment.depth_main || '',
        standard_disp: equipment.standard_disp || '',
        full_load_disp: equipment.full_load_disp || '',
        stand_draft: equipment.stand_draft || '',
        full_load_draft: equipment.full_load_draft || '',
        wetted_boot_top: equipment.wetted_boot_top || '',
        engine_rating: equipment.engine_rating || '',
        max_cont_speed: equipment.max_cont_speed || '',
        eco_speed: equipment.eco_speed || '',
        endurance: equipment.endurance || '',
        remark: equipment.remark || '',
        refit_authority: equipment.refit_authority || '',
        signal_name: equipment.signal_name || '',
        address: equipment.address || '',
        contact_number: equipment.contact_number || '',
        nud_email_id: equipment.nud_email_id || '',
        nic_email_id: equipment.nic_email_id || ''
      };
    }
  }

  updateSystem(equipment: any): void {
    this.viewMode = false;
    this.updateDialogConfig.title = 'Update Ship';
    this.isUpdatedialog = true;
    this.selectedsystem = equipment;
    
    // Map data for the reusable dialog
    this.selectedShipData = {
      sr_no: equipment.sr_no || '',
      code: equipment.code || '',
      name: equipment.name || '',
      commission_date: equipment.commission_date || '',
      ops_code: equipment.ops_code || '',
      ship_builder: equipment.ship_builder || '',
      decommission_date: equipment.decommission_date || '',
      displacement: equipment.displacement || '',
      hours_underway: equipment.hours_underway || '',
      distance_run: equipment.distance_run || '',
      decommission_scheduled_date: equipment.decommission_scheduled_date || '',
      sdrsref: equipment.sdrsref || '',
      yard_no: equipment.yard_no || '',
      reference_no: equipment.reference_no || '',
      classification_society: equipment.classification_society || '',
      length_overall: equipment.length_overall || '',
      length_perpen: equipment.length_perpen || '',
      module_breath: equipment.module_breath || '',
      wetted_under_water: equipment.wetted_under_water || '',
      depth_main: equipment.depth_main || '',
      standard_disp: equipment.standard_disp || '',
      full_load_disp: equipment.full_load_disp || '',
      stand_draft: equipment.stand_draft || '',
      full_load_draft: equipment.full_load_draft || '',
      wetted_boot_top: equipment.wetted_boot_top || '',
      engine_rating: equipment.engine_rating || '',
      max_cont_speed: equipment.max_cont_speed || '',
      eco_speed: equipment.eco_speed || '',
      endurance: equipment.endurance || '',
      remark: equipment.remark || '',
      refit_authority: equipment.refit_authority || '',
      signal_name: equipment.signal_name || '',
      address: equipment.address || '',
      contact_number: equipment.contact_number || '',
      nud_email_id: equipment.nud_email_id || '',
      nic_email_id: equipment.nic_email_id || ''
    };
  }


  onSubmitUpdate(formData: any) {
    let sectionId = this.selectedsystem.id;
    let payload = {
      sr_no: formData.sr_no,
      code: formData.code,
      name: formData.name,
      commission_date: formData.commission_date,
      ops_code: formData.ops_code,
      ship_builder: formData.ship_builder,
      decommission_date: formData.decommission_date,
      displacement: formData.displacement,
      hours_underway: formData.hours_underway,
      distance_run: formData.distance_run,
      decommission_scheduled_date: formData.decommission_scheduled_date,
      sdrsref: formData.sdrsref,
      yard_no: formData.yard_no,
      reference_no: formData.reference_no,
      classification_society: formData.classification_society,
      length_overall: formData.length_overall,
      length_perpen: formData.length_perpen,
      module_breath: formData.module_breath,
      wetted_under_water: formData.wetted_under_water,
      depth_main: formData.depth_main,
      standard_disp: formData.standard_disp,
      full_load_disp: formData.full_load_disp,
      stand_draft: formData.stand_draft,
      full_load_draft: formData.full_load_draft,
      wetted_boot_top: formData.wetted_boot_top,
      engine_rating: formData.engine_rating,
      max_cont_speed: formData.max_cont_speed,
      eco_speed: formData.eco_speed,
      endurance: formData.endurance,
      remark: formData.remark,
      refit_authority: formData.refit_authority,
      signal_name: formData.signal_name,
      address: formData.address,
      contact_number: formData.contact_number,
      nud_email_id: formData.nud_email_id,
      nic_email_id: formData.nic_email_id
    };
    
    const sub = this.api.putAPI(`/master/ship/${sectionId}/`, payload).subscribe((res: any) => {
      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Ship updated successfully'
        });
        this.isUpdatedialog = false;
        this.getSystem();
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Failed',
          detail: res.detail || 'Failed to update ship'
        });
      }
    });
    this.subscriptions.add(sub);
  }

  onCancelUpdate() {
    this.isUpdatedialog = false;
  }

  onCloseUpdate() {
    this.isUpdatedialog = false;
  }

  showDeletePopup(equipment: any) {
    this.showDeleteDialog = true;
    this.selectedsystem = equipment
  }
  deleteSystem() {
    // this.selectedsystem = equipment;
    let sectionId = this.selectedsystem.id
    const sub = this.api.deleteAPI(`/master/ship/${sectionId}/`).subscribe({
      next: (res: any) => {
        this.showDeleteDialog = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Ship Deleted Successfully',
        });
        this.getSystem()

      },
      error: (err) => {
        console.error('API Error:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to delete the proposal. Please try again.',
        });
      },
    });
    this.subscriptions.add(sub);
  }
    get canEditSetup(): boolean {
  return this.permissionService.hasPrivilege('/master/ship', 'Edit') ||
         this.permissionService.hasPrivilege('/master/ship', 'Delete') ||
         this.permissionService.hasPrivilege('/master/ship', 'Ship');
}
}
